import * as React from "react";
import { useTheme } from "@mui/material/styles";
import {
	Box,
	Grid,
	Typography,
	Input,
	InputLabel,
	FormControl,
	FormControlLabel,
	Radio,
	RadioGroup,
} from "@mui/material";
import { ucwords, currencyFormat } from "../../../../utils/";
import Image from "../../../ui-components/Image";

export default function Identification({ question, onAnswer = () => {} }) {
	const theme = useTheme();
	const [answer, setAnswer] = React.useState({});

	const handleSetAnswer = (i, value, setWordUC = true, format = "text") => {
		let ans = {};
		ans[i] = setWordUC === true ? ucwords(value.trim()) : value.trim();
        if (format === 'currency') {
            if (ans[i][0] === '$') {
                ans[i] = ans[i].substring(1);
            }
            
            if (!isNaN(parseFloat(ans[i]))) {
                ans[i] = ans[i].replaceAll(',', '');
                ans[i] = currencyFormat(parseFloat(ans[i]));
            }
        }

        if (format === 'phone number') {
            ans[i] = ans[i].replaceAll(' ', '');
            let ansArr = ans[i].split('');
            if (ans[i].length > 4) {
                ansArr.splice(4, 0, ' ')
            }

            if (ans[i].length > 7) {
                ansArr.splice(8, 0, ' ')
            }
            ans[i] = ansArr.join('')
        }

		const newAnswer = { ...answer, ...ans };
		setAnswer(newAnswer);

		let canProceed =
			Object.values(newAnswer).filter((v) => v !== "").length ===
			question.questionList.length;

		onAnswer({
			canProceed,
			answer: newAnswer,
		});
	};

	return (
		<React.Fragment>
			<Box
				sx={{
					width: "100%",
					background: "white",
					pb: 2,
					pt: 3,
					px: 1,
					textAlign: "center",
				}}
				className="image-container"
			>
				<Image
					src={`clipart/${question.questionImage}`}
					style={{
						maxWidth: "100%",
						height: "4rem",
					}}
					skeletonWidth={"4rem"}
					skeletonHeight={"4rem"}
					skeletonStyle={{
						margin: "auto",
					}}
				/>
				<Typography sx={{ px: 10, py: 1 }}>
					{question.questionImageText}
				</Typography>
			</Box>
			<Box className="choices-container">
				<Typography
					variant="h5"
					sx={{
						mt: 1.5,
						textAlign: "center",
						color: theme.palette.primary.main,
						fontWeight: "bold",
					}}
				>
					{question.questionListLabel}
				</Typography>

				{question.questionList.length > 0 &&
					question.questionList.map((q, i) => (
						<Grid
							container
							key={`iden-key-${i}-${Math.random()}`}
							sx={{ p: 2 }}
							gap={1}
							alignItems={q.type === "text" ? "center" : "start"}
						>
							<Grid
								item
								sm={5}
								xs={5}
								sx={{
									textAlign: "right",
									mt: q.type === "radio" ? 1 : 0,
								}}
							>
								<InputLabel
									sx={{ color: theme.palette.primary.main }}
								>
									{q.label}:
								</InputLabel>
							</Grid>
							<Grid item sm={6} xs={6}>
								{q.type === "text" && (
									<Input
                                        // type={q.format === "currency" ? "number": 'text'}
										name={q.value}
										fullWidth
										defaultValue={answer[q.value] || ""}
										// startAdornment={
										// 	q.format === "currency" ? (
										// 		<InputAdornment position="start">
										// 			$
										// 		</InputAdornment>
										// 	) : (
										// 		""
										// 	)
										// }
										onBlur={(e) => {
											handleSetAnswer(
												q.value,
												e.target.value,
												true,
												q.format || ""
											);
										}}
									/>
								)}
								{q.type === "radio" && (
									<FormControl>
										<RadioGroup
											aria-labelledby="demo-controlled-radio-buttons-group"
											name="controlled-radio-buttons-group"
										>
											{q.choices.map((choice, i) => (
												<FormControlLabel
													key={`q-choice=${i}-${Math.random()}`}
													value={
														choice.value || choice
													}
													checked={
														answer[q.value] ===
														(choice.value || choice)
													}
													onChange={(e) => {
														handleSetAnswer(
															q.value,
															e.target.value,
															false
														);
													}}
													control={<Radio />}
													label={
														choice.label || choice
													}
												/>
											))}
										</RadioGroup>
									</FormControl>
								)}
							</Grid>
						</Grid>
					))}
			</Box>
		</React.Fragment>
	);
}
